import { render } from "./App.vue?vue&type=template&id=778438c0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=778438c0&lang=css"
import "./App.vue?vue&type=style&index=1&id=778438c0&scoped=true&lang=scss"

import exportComponent from "D:\\work\\webGl\\chery-ruihu9\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778438c0"]])

export default __exports__